export const boolItem = {
    binary: "uint",
    size: 1,
    custom: {
        to: (encoded) => encoded > 0,
        from: (val) => (val ? 1 : 0),
    },
};
//# sourceMappingURL=boolean.js.map